exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cc-panel-default[data-v-3fb6b198]:hover{background-color:#fcf8e3}.cc-msg[data-v-3fb6b198]{overflow:hidden;white-space:nowrap;margin-right:10px}.panel .fa[data-v-3fb6b198],h2 .fa[data-v-3fb6b198]{padding-right:2px}.fa-send[data-v-3fb6b198]{color:#449d44}.fa-trash[data-v-3fb6b198]{color:#f0ad4e}.fa-times-circle[data-v-3fb6b198]{color:#d9534f}.fa-thumb-tack[data-v-3fb6b198]{color:#337ab7}small[data-v-3fb6b198]{color:gray}.panel[data-v-3fb6b198]{margin-bottom:4px;border-bottom:1px solid #d3d3d3}.panel-title[data-v-3fb6b198]{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3fb6b198&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/HistoryItem.vue
// module id = 199
// module chunks = 0